import { useChatStore } from "../stores/ChatStore";
import { useCallback } from "react";

import ChatDatasetSelectionBtn from "src/reusable/Chat/PromptInput/ChatDatasetSelectionBtn";
import { useChatStreamIfAvailable } from "src/reusable/Chat/ChatStreaming/hooks/useChatStream";

type AADatasetSelectionBtn = {
  onlyIcon?: boolean;
};

const AADatasetSelectionBtn = ({ onlyIcon }: AADatasetSelectionBtn) => {
  const { setDatasets: setDatasetsStore, dropdownDatasets } = useChatStore();

  // Nullable: the splash page renders this outside any chat provider.
  const chat = useChatStreamIfAvailable();
  const setResponseSources = chat?.setResponseSources ?? null;

  const setDatasets = useCallback(
    (datasets: any[]) => {
      // Get current config from store to avoid stale closure
      const currentConfig = useChatStore.getState().config;
      const previousDatasets = currentConfig?.datasets || [];

      // Use granular setDatasets to avoid resetting other state
      setDatasetsStore(datasets);

      // Clear response sources if datasets were removed and we're in a chat context
      if (datasets.length < previousDatasets.length && setResponseSources) {
        setResponseSources([]);
      }
    },
    [setDatasetsStore, setResponseSources],
  );

  const handleSelectedOptions = useCallback(
    (datasets: any[]) => {
      setDatasets(datasets);
    },
    [setDatasets],
  );

  // Only pass dropdown datasets to the selector button
  // Project datasets are "inherited" from the project and should not appear in the selector
  // Uploaded files are managed separately by the file upload system and should not appear in dataset dropdown
  // They will still be included in API requests via useActiveDatasetIds()
  const userControllableDatasets = [...dropdownDatasets];

  return (
    <ChatDatasetSelectionBtn
      handleSelectedOptions={handleSelectedOptions}
      defaultSelectedDatasets={userControllableDatasets}
      onlyIcon={onlyIcon}
    />
  );
};

export default AADatasetSelectionBtn;
